import React from 'react';
import { withNamespaces, Trans } from 'react-i18next';

const validationRules = {
    login: {
        presence: {
            allowEmpty: false,
            message: <Trans i18nKey="validationRules.required-message"/>,
        },
        // format: {
        //   pattern: /^[a-zA-Z0-9]+$/,
        //   flags: "i",
        //   message: <Trans i18nKey="validationRules.login-message"/>
        // }
    },
    password: {
        presence: {
            allowEmpty: false,
            message: <Trans i18nKey="validationRules.required-message"/>,
        },
        // length: {
        //     minimum: 8,
        //     message: <Trans i18nKey="validationRules.password-message"/>
        // }
    },
    username: {
        presence: {
            allowEmpty: false,
            message: <Trans i18nKey="validationRules.required-message"/>,
        },
    },
    company: {
        presence: {
            allowEmpty: false,
            message: <Trans i18nKey="validationRules.required-message"/>,
        },
    },
    phone: {
        presence: {
            allowEmpty: false,
            message: <Trans i18nKey="validationRules.required-message"/>,
        },
        format: {
            pattern: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/, // eslint-disable-line 
            flags: "i",
            message: <Trans i18nKey="validationRules.phone-message"/>
        }
    },
    userdata_phone: {
        // presence: {
        //     allowEmpty: false,
        //     message: <Trans i18nKey="validationRules.required-message"/>,
        // },
        format: {
            pattern: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/, // eslint-disable-line 
            flags: "i",
            message: <Trans i18nKey="validationRules.phone-message"/>
        }
    },
    email: {
        presence: {
            allowEmpty: false,
            message: <Trans i18nKey="validationRules.required-message"/>,
        },
        email: {
            message: <Trans i18nKey="validationRules.email-message"/>
        },
    },
    // mobDate: {
    //     presence: {
    //         allowEmpty: false,
    //         message: <Trans i18nKey="validationRules.required-message"/>,
    //     },
    //     format: {
    //         pattern: /^(0?[1-9]|[12][0-9]|3[01]).(0?[1-9]|1[012]).\d{2}$/, // eslint-disable-line 
    //         flags: "g",
    //         message: <Trans i18nKey="validationRules.date-message"/>
    //     }
    // },
    // desktopDate: {
    //     presence: {
    //         allowEmpty: false,
    //         message: <Trans i18nKey="validationRules.required-message"/>,
    //     },
    //     format: {
    //         pattern: /^(0?[1-9]|[12][0-9]|3[01]).(0?[1-9]|1[012]).\d{2}$/, // eslint-disable-line 
    //         flags: "g",
    //         message: <Trans i18nKey="validationRules.date-desktop-message"/>
    //     }
    // },
}

export default withNamespaces('translation')(validationRules);


// WEBPACK FOOTER //
// ./src/utils/validator.js